import React, { useEffect, useState } from 'react';
import { useLogin } from 'hooks/login-hooks';
import { useMobile } from 'hooks/responsive-hooks';
import useTranslation from 'hooks/use-translation';
import { onEventModalDisplay } from 'service/gtm';
import Modal from './storybook/UI/Modal/modal';

export default function EventModal() {
  const [isOpen, setIsOpen] = useState(false);
  const { isLoggedIn } = useLogin();
  const isMobile = useMobile();
  const { t } = useTranslation();

  const isPartner =
    typeof window !== 'undefined' && window.location.pathname.includes('partenaires');

  useEffect(() => {
    if (isMobile || isPartner) return;

    if (isLoggedIn && !localStorage.getItem('showOfferModal')) {
      localStorage.setItem('showOfferModal', 'true');
      setIsOpen(true);
      onEventModalDisplay(true);
    } else if (!isLoggedIn && !sessionStorage.getItem('showOfferModal')) {
      sessionStorage.setItem('showOfferModal', 'true');
      setIsOpen(true);
      onEventModalDisplay(false);
    }
  }, [isLoggedIn, isMobile, isPartner]);

  if (isLoggedIn) {
    return (
      <Modal onRequestClose={() => setIsOpen(false)} isOpen={isOpen}>
        <div className="not-logged-in-modal">
          <h1 className="modal-title">{t('eventModalTitle')}</h1>
          <div className="double-content-text">
            <p className="modal-text">{t('eventModalContent2')}</p>
            <p className="modal-text blue">
              <strong>{t('eventModalContent3')}</strong>
            </p>
            <p className="modal-text">{t('eventModalContent4')}</p>
          </div>
          <a href="/">
            <button style={{ textTransform: 'uppercase' }}>{t('eventModalButton')}</button>
          </a>
        </div>
      </Modal>
    );
  }

  return (
    <Modal onRequestClose={() => setIsOpen(false)} isOpen={isOpen}>
      <div className="not-logged-in-modal">
        <h1 className="modal-title">{t('eventModal2Title')}</h1>
        <p className="modal-text">{t('eventModal2Content1')}</p>
        <div className="double-content-text2">
          <p className="modal-text">{t('eventModal2Content2')}&nbsp;</p>
          <p className="modal-text blue">
            <strong>{t('eventModal2Content3')}&nbsp;</strong>
          </p>
          <p className="modal-text">{t('eventModal2Content4')} :</p>
        </div>
        <p className="modal-text blue">
          <strong>{t('discountModal2Code')}</strong>
        </p>
        <a href="/">
          <button style={{ textTransform: 'uppercase' }}>{t('eventModal2Button')}</button>
        </a>
      </div>
    </Modal>
  );
}
